import CalenderTextSlider from './CalenderTextSlider';

export default CalenderTextSlider;
